// extracted by mini-css-extract-plugin
export var pillWrapper = "_ql-0";
export var showOverflow = "_ql-1";